export const inspectionCategories = [
  {
    name: "BATHROOMS",
    items: [
      { id: "bath-1", label: "Faucets & water pressure", status: null },
      { id: "bath-2", label: "Toilet operation & seals", status: null },
      { id: "bath-3", label: "Caulking & grout condition", status: null },
    ]
  },
  {
    name: "KITCHEN",
    items: [
      { id: "kit-1", label: "Appliance operation", status: null },
      { id: "kit-2", label: "Countertop & cabinet condition", status: null },
      { id: "kit-3", label: "Plumbing under sink", status: null },
      { id: "kit-4", label: "Ventilation / range hood", status: null },
    ]
  },
  {
    name: "INSULATION & VENTILATION",
    items: [
      { id: "ins-1", label: "Attic insulation depth", status: null },
      { id: "ins-2", label: "Vapor barriers", status: null },
      { id: "ins-3", label: "Bathroom exhaust fans", status: null },
      { id: "ins-4", label: "Dryer venting", status: null },
    ]
  },
  {
    name: "HVAC",
    items: [
      { id: "hvac-1", label: "Furnace age & condition", status: null },
      { id: "hvac-2", label: "AC unit operation", status: null },
      { id: "hvac-3", label: "Ductwork condition", status: null },
      { id: "hvac-4", label: "Thermostat function", status: null },
      { id: "hvac-5", label: "Filter condition", status: null },
    ]
  },
  {
    name: "ELECTRICAL",
    items: [
      { id: "elec-1", label: "Panel capacity & condition", status: null },
      { id: "elec-2", label: "GFCI outlets in wet areas", status: null },
      { id: "elec-3", label: "Wiring type (copper vs aluminum)", status: null },
      { id: "elec-4", label: "Smoke & CO detectors", status: null },
    ]
  },
  {
    name: "PLUMBING",
    items: [
      { id: "plumb-1", label: "Water heater age & condition", status: null },
      { id: "plumb-2", label: "Main shutoff valve", status: null },
      { id: "plumb-3", label: "Drain speed all sinks", status: null },
      { id: "plumb-4", label: "Water supply lines", status: null },
      { id: "plumb-5", label: "Sump pump (if applicable)", status: null },
    ]
  },
  {
    name: "INTERIOR - STRUCTURE",
    items: [
      { id: "int-1", label: "Foundation cracks", status: null },
      { id: "int-2", label: "Floor levelness", status: null },
      { id: "int-3", label: "Wall/ceiling cracks", status: null },
      { id: "int-4", label: "Window operation & seals", status: null },
      { id: "int-5", label: "Door operation", status: null },
    ]
  },
  {
    name: "EXTERIOR - GROUNDS",
    items: [
      { id: "ext-g-1", label: "Grading & drainage", status: null },
      { id: "ext-g-2", label: "Driveway condition", status: null },
      { id: "ext-g-3", label: "Fence condition", status: null },
      { id: "ext-g-4", label: "Deck/patio condition", status: null },
    ]
  },
  {
    name: "EXTERIOR - WALLS",
    items: [
      { id: "ext-w-1", label: "Siding condition", status: null },
      { id: "ext-w-2", label: "Paint / finish", status: null },
      { id: "ext-w-3", label: "Trim & fascia", status: null },
    ]
  },
  {
    name: "EXTERIOR - ROOF",
    items: [
      { id: "ext-r-1", label: "Shingle condition & age", status: null },
      { id: "ext-r-2", label: "Flashing & seals", status: null },
      { id: "ext-r-3", label: "Gutters & downspouts", status: null },
      { id: "ext-r-4", label: "Soffit & fascia", status: null },
      { id: "ext-r-5", label: "Chimney condition", status: null },
    ]
  },
];

export const moveInTasks = [
  {
    id: "task-1", title: "Book Electricity Connection", provider: "Your local hydro provider",
    phone: "", website: "", cost: "$120/month",
    note: "Call at least 2 weeks before closing to schedule connection for closing day",
    category: "Utilities", priority: "high", status: "Not Started",
    ottawaTitle: "Book Hydro Ottawa Connection", ottawaProvider: "Hydro Ottawa",
    ottawaPhone: "613-738-6400", ottawaWebsite: "https://hydroottawa.com"
  },
  {
    id: "task-2", title: "Set Up Enbridge Gas", provider: "Enbridge Gas",
    phone: "1-877-362-7434", website: "https://www.enbridge.com", cost: "$80/month",
    note: "Transfer or set up new gas account",
    category: "Utilities", priority: "high", status: "Not Started"
  },
  {
    id: "task-3", title: "Internet & Cable Setup", provider: "Bell / Rogers",
    phone: "", website: "https://www.bell.ca", cost: "$80-150/month",
    note: "Book installation appointment for move-in day or week",
    category: "Utilities", priority: "medium", status: "Not Started"
  },
  {
    id: "task-4", title: "Water Heater Rental Transfer", provider: "Reliance / Enercare",
    phone: "1-888-837-1451", website: "https://www.reliancehomecomfort.com", cost: "$30-50/month",
    note: "Check if rental transfer is needed from previous owner",
    category: "Utilities", priority: "medium", status: "Not Started"
  },
  {
    id: "task-5", title: "Update Home Insurance", provider: "",
    phone: "", website: "", cost: "",
    note: "Confirm policy is active for closing date. Provide to your lawyer.",
    category: "Utilities", priority: "high", status: "Not Started"
  },
  {
    id: "task-6", title: "Hire Moving Company", provider: "",
    phone: "", website: "https://www.moving.ca", cost: "$800-2,000",
    note: "Get at least 3 quotes. Book well in advance for month-end moves.",
    category: "Services", priority: "medium", status: "Not Started"
  },
  {
    id: "task-7", title: "Update Address - CRA", provider: "Canada Revenue Agency",
    phone: "1-800-959-8281", website: "https://www.canada.ca/en/revenue-agency", cost: "",
    note: "Update through My Account or by calling CRA",
    category: "Admin", priority: "medium", status: "Not Started"
  },
  {
    id: "task-8", title: "Update Address - Driver's License", provider: "ServiceOntario",
    phone: "1-800-267-8097", website: "https://www.ontario.ca/page/change-address-drivers-licence", cost: "",
    note: "Must update within 6 days of moving",
    category: "Admin", priority: "high", status: "Not Started"
  },
  {
    id: "task-9", title: "Change Locks", provider: "",
    phone: "", website: "", cost: "$150-400",
    note: "Change all exterior locks on closing day for security",
    category: "Home Prep", priority: "high", status: "Not Started"
  },
  {
    id: "task-10", title: "Deep Clean Before Move-In", provider: "",
    phone: "", website: "", cost: "$200-500",
    note: "Professional cleaning recommended before moving furniture in",
    category: "Home Prep", priority: "medium", status: "Not Started"
  },
  {
    id: "task-11", title: "Set Up Mail Forwarding", provider: "Canada Post",
    phone: "1-866-607-6301", website: "https://www.canadapost-postescanada.ca/cpc/en/support/kb/receiving/mail-forwarding", cost: "$75-100",
    note: "Set up mail forwarding for at least 6 months",
    category: "Home Prep", priority: "low", status: "Not Started"
  },
  {
    id: "task-12", title: "Arrange Moving Day Logistics", provider: "",
    phone: "", website: "", cost: "",
    note: "Plan parking, elevator booking (if condo), key pickup timing",
    category: "Moving", priority: "medium", status: "Not Started"
  },
];

export const insuranceTypes = [
  {
    title: "Home Insurance (Property Insurance)",
    badge: "Required",
    badgeColor: "#2d8a4e",
    protects: "You & your lender",
    cost: "$800-$2,500/year",
    when: "3-4 weeks before closing",
    description: "Protects your home and belongings. No policy = no mortgage funding = no keys.",
    learnMore: {
      whatItCovers: "Home insurance covers your dwelling (the structure), personal property (belongings), liability (if someone is injured on your property), and additional living expenses if your home becomes uninhabitable due to a covered event like fire or water damage.",
      whatItDoesNotCover: "Standard policies typically exclude floods, earthquakes, sewer backup (unless added as a rider), gradual wear and tear, pest infestations, and intentional damage. Overland water coverage is increasingly important in many Canadian cities due to spring flooding risks.",
      howToGetIt: "Contact at least 3 insurance brokers or companies for quotes. You'll need your home's address, age, square footage, heating type, roof age, and details about renovations. Your lender will require proof of insurance before releasing mortgage funds.",
      tips: [
        "Bundle home and auto insurance for 10-20% savings",
        "Ask about replacement cost vs. actual cash value coverage",
        "Increase your deductible to lower premiums",
        "Document your belongings with photos for claims",
        "Review and update your policy annually",
      ],
    },
  },
  {
    title: "Title Insurance",
    badge: "Conditional",
    badgeColor: "#e8972c",
    protects: "You",
    cost: "$250-$500 one-time",
    when: "At closing (lawyer arranges)",
    description: "Protects your legal ownership. Pay once, covered forever.",
    learnMore: {
      whatItCovers: "Title insurance protects against title fraud, errors in public records, unknown liens or encumbrances, boundary disputes, zoning issues, and problems that a standard title search might miss. It also covers legal fees if your title is ever challenged.",
      whatItDoesNotCover: "Title insurance does not cover issues you already know about at the time of purchase, environmental contamination, Indigenous land claims, or matters that would be revealed by an up-to-date survey that you chose not to obtain.",
      howToGetIt: "Your real estate lawyer will typically arrange title insurance as part of the closing process. They'll recommend a provider and include the one-time premium in your closing costs. No medical exam or ongoing payments required.",
      tips: [
        "It replaces the need for an up-to-date property survey in most cases",
        "One-time payment provides lifetime coverage",
        "Both owner's and lender's policies are available",
        "Most lawyers strongly recommend it for peace of mind",
        "It can protect against title fraud, which is increasing in Canada",
      ],
    },
  },
  {
    title: "CMHC / Mortgage Default Insurance",
    badge: "Conditional",
    badgeColor: "#e8972c",
    protects: "Your lender (not you)",
    cost: "2.80-4.00% of mortgage (added to balance)",
    when: "Calculated at mortgage approval",
    description: "Lets you buy with less than 20% down. The cost gets added to your mortgage.",
    learnMore: {
      whatItCovers: "Mortgage default insurance protects the lender if you stop making mortgage payments. It's required by law for any mortgage with less than 20% down payment. While it protects the lender, it benefits you by allowing you to purchase a home with as little as 5% down.",
      whatItDoesNotCover: "This insurance does not protect you as the borrower. If you default on your mortgage, you could still lose your home and owe any remaining balance. It does not cover job loss, disability, or any personal financial hardship.",
      howToGetIt: "Your lender arranges this automatically if your down payment is less than 20%. The premium is calculated based on your loan-to-value ratio and added to your mortgage balance. Providers include CMHC, Sagen, and Canada Guaranty.",
      tips: [
        "The premium ranges from 2.80% (15-19.99% down) to 4.00% (5-9.99% down)",
        "It's added to your mortgage balance and amortized over the life of the loan",
        "You may be able to port the insurance if you switch lenders",
        "Properties over $1 million are not eligible for default insurance",
        "A larger down payment significantly reduces the insurance cost",
      ],
    },
  },
  {
    title: "Mortgage Life Insurance (Bank's Product)",
    badge: "Optional",
    badgeColor: "#dc3545",
    protects: "Your lender (pays off mortgage)",
    cost: "$30-$80/month",
    when: "Offered at mortgage signing",
    description: "The bank's version. Coverage shrinks, premiums don't. There's a better option.",
    learnMore: {
      whatItCovers: "Bank mortgage life insurance pays off your remaining mortgage balance if you pass away. Some policies also offer critical illness coverage. The payout goes directly to the lender to clear the mortgage debt.",
      whatItDoesNotCover: "Coverage decreases as you pay down your mortgage, but your premiums stay the same. You cannot choose your beneficiary (the bank is always the beneficiary). Pre-existing conditions discovered after purchase may void the policy. It is not portable if you switch lenders.",
      howToGetIt: "Your bank will offer this when you sign your mortgage documents. It's convenient but generally not the best value. You can decline it and get a separate term life insurance policy instead, which offers better coverage at a lower cost.",
      tips: [
        "Coverage decreases over time while premiums stay the same",
        "Post-claim underwriting means the bank checks your health after a claim",
        "A separate term life policy is almost always a better deal",
        "You cannot choose your beneficiary with bank mortgage insurance",
        "Compare costs with an independent term life insurance quote",
      ],
    },
  },
  {
    title: "Term Life Insurance",
    badge: "Recommended",
    badgeColor: "#2d8a4e",
    protects: "Your family",
    cost: "$20-$50/month",
    when: "Before or after closing",
    description: "Better alternative to bank mortgage insurance. Coverage stays level, you choose beneficiary, portable between lenders.",
    learnMore: {
      whatItCovers: "Term life insurance provides a fixed death benefit for a set period (typically 10, 20, or 30 years). Your family receives the full payout and can use it however they need: pay off the mortgage, cover living expenses, fund education, or anything else.",
      whatItDoesNotCover: "Term life insurance does not build cash value like whole life insurance. Coverage ends when the term expires, and renewal premiums are significantly higher. It does not cover pre-existing conditions excluded during underwriting.",
      howToGetIt: "Contact an independent insurance broker who can compare policies from multiple providers. You'll need a medical questionnaire and possibly a medical exam. Apply before or shortly after your home purchase for the best rates while you're young and healthy.",
      tips: [
        "Get coverage equal to your mortgage plus 2-3 years of living expenses",
        "Lock in rates while you're young and healthy",
        "Choose a term that matches your mortgage amortization",
        "Coverage amount stays level even as your mortgage decreases",
        "You choose the beneficiary, giving your family flexibility",
      ],
    },
  },
  {
    title: "Disability / Critical Illness Insurance",
    badge: "Optional",
    badgeColor: "#dc3545",
    protects: "Your income & mortgage payments",
    cost: "$40-$100/month",
    when: "Any time",
    description: "Covers mortgage payments if you can't work due to illness or disability.",
    learnMore: {
      whatItCovers: "Disability insurance replaces a portion of your income (typically 60-70%) if you become unable to work due to illness or injury. Critical illness insurance provides a lump-sum payment upon diagnosis of a covered condition such as cancer, heart attack, or stroke.",
      whatItDoesNotCover: "Disability insurance typically has a waiting period (30-90 days) before benefits begin. Pre-existing conditions may be excluded. Critical illness policies only cover specific listed conditions and may not pay out for less severe forms of covered illnesses.",
      howToGetIt: "An independent insurance broker can help you compare disability and critical illness policies. Your employer may already offer group disability coverage, so check your benefits first. Individual policies offer more comprehensive coverage but cost more.",
      tips: [
        "Check if your employer already provides group disability coverage",
        "Individual policies are portable and stay with you if you change jobs",
        "Consider both short-term and long-term disability coverage",
        "Critical illness insurance can cover mortgage payments during recovery",
        "The younger you are when you apply, the lower your premiums",
      ],
    },
  },
  {
    title: "Sewer Backup Rider",
    badge: "Optional",
    badgeColor: "#6b7280",
    protects: "You",
    cost: "$50-$150/year",
    when: "Add when purchasing home insurance",
    description: "The #1 overlooked add-on. Most common insurance claim in Canadian homes. Get it.",
    learnMoreType: "sections",
    learnMore: {
      sections: [
        {
          title: "What is it?",
          content: "A sewer backup rider is an add-on to your standard home insurance policy that covers damage caused by water or sewage backing up through drains, toilets, or sump pumps. Standard home insurance does NOT cover this. It's a separate endorsement you need to specifically request.",
          bullet: "Add when purchasing home insurance or anytime after. $50-$150/year depending on coverage limits and deductible.",
          callout: "This is the single most common insurance claim in Canadian homes \u2014 especially in older neighborhoods and areas with combined sewer systems. Get it.",
        },
        {
          title: "Why you need it",
          content: "Sewer backups happen more often than you think: heavy rainfall overwhelming city systems, tree roots blocking pipes, aging infrastructure, or a failed sump pump. In Ottawa and across Canada, thousands of sewer backup claims every year. A single incident can cause $10,000-$50,000 in damage to flooring, drywall, furniture, and personal belongings.",
          bullet: "Average claim: $15,000-$30,000",
          callout: "If your home was built before 1980 or you have a finished basement, this is essential.",
        },
        {
          title: "What it covers",
          content: "Water damage from: sewage backing up through drains or toilets, sump pump failure, flood water entering through foundation drains. Also covers: cleanup and restoration, damaged flooring and drywall, ruined furniture and belongings, temporary living expenses if the home is uninhabitable.",
          bullet: "Coverage limits typically range from $10,000 to $50,000",
          callout: "Choose a coverage limit that reflects the value of your basement contents and potential repair costs.",
        },
        {
          title: "What it doesn't cover",
          content: "Overland flooding (rising water from outside your property) is NOT covered by a sewer backup rider. That requires a separate overland flood insurance policy. Also not covered: gradual seepage, maintenance issues you ignored, or backup caused by your own negligence.",
          bullet: "Overland flood insurance is a separate policy (more expensive)",
          callout: "Don't confuse sewer backup with overland flood coverage \u2014 they're different risks.",
        },
        {
          title: "Ottawa-specific risk",
          ottawaOnly: true,
          content: "Ottawa has aging sewer infrastructure and is prone to heavy spring rainfall and rapid snowmelt. Many older neighborhoods have combined sewer systems (storm water and sewage in the same pipes) which are easily overwhelmed during heavy rain. Sewer backup claims spike every spring in Ottawa.",
          bullet: "Especially important in older neighborhoods: Westboro, Glebe, Old Ottawa South, Vanier. City of Ottawa offers subsidies for backwater valve installation ($1,250-$1,750).",
          callout: "Ask your home inspector if the property has a backwater valve installed. If not, consider getting one.",
        },
        {
          title: "Prevention tips",
          content: "Install a backwater valve (mechanical device that prevents sewage from flowing back into your home). Keep floor drains clear and test your sump pump annually. Avoid flushing grease, wipes, or other items that can clog pipes. Consider a battery backup for your sump pump.",
          bullet: "Backwater valve installation before closing or in first year. Installation cost: $2,000-$3,500 (minus city subsidy).",
          callout: "Many insurers offer discounts if you have a backwater valve installed. Ask.",
        },
      ],
    },
  },
  {
    title: "SecureMyOffer (Buyer Default Protection)",
    badge: "Optional",
    badgeColor: "#6b7280",
    protects: "Seller (protects your equity)",
    cost: "Varies by property. Coverage up to $250K",
    when: "Within 10 days of offer going firm",
    description: "The only product in Canada that protects sellers when a buyer defaults. Covers shortfall, carrying costs, legal fees.",
    learnMoreType: "narrative",
    learnMore: {
      subtitle: "Buyer Default Protection",
      tagline: "The first and only insurance product in Canada designed to protect sellers when a buyer defaults after the deal goes firm.",
      sections: [
        {
          title: "What It Is",
          content: "SecureMyOffer is backed by Accelerant Insurance Company of Canada (AM Best A-Rated). It launched in Ontario after two years of regulatory approval. It's designed specifically for situations where a buyer defaults after a deal goes firm. Instead of forcing the seller to relist, absorb the loss, or scramble to protect their next purchase, SecureMyOffer provides a structured way for sellers to protect their equity and move forward with certainty.",
        },
        {
          title: "Why It Matters to You as a Buyer",
          content: "Understanding SecureMyOffer helps you in two ways:",
          bullets: [
            "If you're also selling a home, it protects YOUR sale from falling apart if your buyer defaults.",
            "If the seller on the home you're buying has SecureMyOffer, they may be more willing to negotiate because they feel financially protected. Protected sellers make calmer, better decisions.",
          ],
          callout: "If you're doing a conditional sale (selling your current home to buy a new one), this is especially relevant to your situation.",
        },
        {
          title: "What It Covers",
          content: "When a buyer defaults after going firm, SecureMyOffer steps in:",
          bullets: [
            "Unlocks up to 95% loan-to-value so sellers can access their equity on closing day",
            "Covers shortfall if the resale price drops \u2014 up to 20% of the property's value (maximum $250,000)",
            "Covers carrying costs: mortgage payments, property taxes, utilities, cleaning, staging",
            "Covers agent commissions up to $25,000",
            "Pays all legal fees and pursues recovery from the defaulting buyer",
          ],
        },
        {
          title: "The Gap It Fills",
          content: "Right now, if a buyer defaults, the seller's only recourse is to: relist the property and hope to match the original price, sue the defaulting buyer (which takes years and costs thousands), or absorb the financial loss. When sellers relist quickly under duress, they lose an average of $63,000+ on the second sale. SecureMyOffer eliminates that risk.",
          highlight: "Home insurance doesn't cover this. Title insurance doesn't cover this. CMHC doesn't cover this. Nothing else on the market addresses buyer default.",
        },
        {
          title: "How to Get It",
          content: "Coverage must be purchased within 10 days of the offer going firm. Your real estate agent or lawyer can help arrange it. The conversation needs to happen early in the process \u2014 not when a deal is already in trouble.",
        },
        {
          title: "If the Property Resells for a Gain",
          content: "If SecureMyOffer relists and sells the property for MORE than the original offer price, 100% of the profit goes to the seller. They also replace the entire existing mortgage so the seller can port it to their next property without any disruption.",
        },
      ],
      ctaText: "Learn More at securemyoffer.com",
      ctaUrl: "https://securemyoffer.com",
    },
  },
];

export const nudgesData = [
  {
    id: "nudge-1",
    trigger: "Offer Acceptance Date",
    type: "Dynamic",
    title: "Congratulations! Your Offer is Accepted!",
    timing: "Same Day (upon date entry)",
    message: "Congratulations, your offer is accepted! Speak with your agent to book your inspection now and submit your documents to your lender for review to avoid any troubles during the conditional period.",
    cta: "Go to Home Buying Timeline",
    ctaRoute: "/reports",
  },
  {
    id: "nudge-2",
    trigger: "25% Through Conditional",
    type: "Dynamic",
    title: "Reminder: Did You Book Your Home Inspection?",
    timing: "25% through conditional period",
    message: "Just a friendly reminder to book your home inspection. This is a critical step, and getting it done early gives you more time to review the report.",
    cta: "Review Home Inspection Checklist",
    ctaRoute: "/inspection",
  },
  {
    id: "nudge-3",
    trigger: "50% Through Conditional",
    type: "Dynamic",
    title: "Reminder: How's Your Financing Coming Along?",
    timing: "50% through conditional period",
    message: "You're halfway through your conditional period. Make sure your financing is on track and all documents have been submitted to your lender.",
    cta: "Check Budget Planner",
    ctaRoute: "/budget",
  },
  {
    id: "nudge-4",
    trigger: "75% Through Conditional",
    type: "Dynamic",
    title: "Final Push: Conditions Removal Coming Up",
    timing: "75% through conditional period",
    message: "Your condition removal date is approaching. Review your inspection findings, confirm financing, and prepare to waive or negotiate conditions.",
    cta: "Review Documents",
    ctaRoute: "/documents",
  },
  {
    id: "nudge-5",
    trigger: "2 Weeks Before Closing",
    type: "Dynamic",
    title: "Closing Day is Approaching!",
    timing: "14 days before closing",
    message: "Your closing day is two weeks away! Time to set up utilities, arrange moving logistics, and confirm everything with your lawyer.",
    cta: "View Move-In Checklist",
    ctaRoute: "/move-in",
  },
];
